/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { features, language, icd10codes, treatment } from "config";
import { FirebaseContext } from "common";
import { Button, Input, FormText, Alert } from "reactstrap";
import { Paper, Select, MenuItem, Tab, Tabs } from "@material-ui/core";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Collapse,
} from "reactstrap";
// import Select from "react-select";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Material_React_Table from "../components/React_Material_Table/Material_React_Table_NoAdd";
import { Box } from "@mui/material";

export default function PracticeDetails() {
  const { api } = useContext(FirebaseContext);
  const { editPracticeType ,fetchPracticeTypes} = api;

  const [data, setData] = useState([]);


  const [editingPractice, setEditingPractice] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [originalPracticeInjected, setOriginalPracticeInjected] = useState(false);

  const [savingPractice, setSavingPractice] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const practicetypes = useSelector((state) => state.practicetypes);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [practices, setPractices] = useState({});
  const usersdata = useSelector((state) => state.doctors);

  const specialities = useSelector(
    (state) => state.specialitytypes.specialities
  );
  // const codes = useSelector((state) => state.icdcodes.codes);
  const [specialityTypes, setSpecialityTypes] = useState({});
  const [selectedSpecialityDetails, setSelectedSpecialityDetails] =
    useState(null);
  const [openFPModal, setOpenFPModal] = React.useState(false);
  const [service, setservice] = useState([]);
  const [serviceT, setserviceT] = useState([]);
  const [treatments, settreatments] = useState([]);
  useEffect(() => {
    // console.log("treat", treatment);
    if (treatment) {
      let arr = [];
      for (let i = 0; i < Object.keys(treatment).length; i++) {
        arr.push({
          value: Object.values(treatment)[i],
          label: Object.keys(treatment)[i],
        });
      }
      setservice(arr);
    }
  }, []);
  useEffect(() => {
    if (serviceT) {
      let arr = [];
      for (let i = 0; i < Object.keys(serviceT).length; i++) {
        arr.push({
          value: Object.values(serviceT)[i],
          label: Object.keys(serviceT)[i],
        });
      }
      settreatments(arr);
    }
  }, [serviceT]);

  useEffect(() => {
    if (specialities) {
      let arr = [{}];

      for (let i = 0; i < specialities.length; i++) {
        arr.push({
          value: specialities[i],
        });
      }

      setSpecialityTypes(arr);
      // console.log("specialityTypes2", arr);
    }
  }, []);

  
  const [state, setstate] = useState({
    practiceName: auth.info.profile.practiceName,
    practiceNumber: auth.info.profile.practiceNumber,
    specialityType: auth.info.profile.specialityType || false,
    treatmentType: auth.info.profile.treatmentType || false,
    // fees: "",
    extra_info:auth.info.profile.extra_info || "",
    base_fare: "",
    base_rate: "",
    consultation_duration: false,
    convenience_fee_type: false,
    convenience_fees: "",
    dispensing_fee: "",
    min_charge: "",
    min_fare: "",
    rate_per_unit_distance: "",
    rate_per_hour: "",
    address:"",
  });
  // const [practiceNamestate, setpracticeNamestate] = useState("");
  // const [practiceNumstate, setpracticeNumstate] = useState("");
  // const [serviceTypestate, setserviceTypestate] = useState(false);
  // const [treatmentTypestate, settreatmentTypestate] = useState(false);
  // const [feesState, setfeesState] = useState("");
  // const [extainfostate, setextainfostate] = useState("");
  useEffect(() => {
    if (specialities) {
      let obj = {};
      for (let i = 0; i < specialities.length; i++) {
        specialities.map((speciality) => (obj[speciality] = speciality));
      }
      setSpecialityTypes(obj);
    }
  }, [specialities]);

  // useEffect(() => {
  //   if (practicetypes.practices) {
  //     let arr = practicetypes.practices.filter((prac) => {
  //       // console.log(prac);
  //       // console.log(auth.info.profile.practiceNumber);
  //       if (prac.practiceNumber === auth.info.profile.practiceNumber) {
  //         return prac;
  //       }
  //     });
  //     setData(arr);
  //   } else {
  //     let arr = practicetypes.practices.filter((prac) => {
  //       console.log(prac);
  //       console.log(auth.info.profile.practiceNumber);

  //       return prac;
  //     });
  //     setData(arr);
  //   }
  // }, [auth.info.profile.practiceNumber, practicetypes.practices]);
  //does all the practice details require a prac Num or can it be handled in the code auto
  // but does it also mean that there wont be different practice numbers



  const handleOpenEvent = (e) => {
    e.preventDefault();
    setOpenFPModal(true);
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    setOpenFPModal(false);
  };
  const toggle = () => setModal(!modal);
  const toggleTwo = () => setIsOpen(!isOpen);
  // const onAdd = () => {
  //   dispatch(editPracticeType(state, "Add"));
  //   return toggle;
  // };


const onAdd = async () => {
  console.log("onAdd called : (entry)");

  // snapshot state early (stringify to freeze the current object)
  console.log("state snapshot:", JSON.stringify(state));

  // show specific fields used in validation
  console.log("practiceName:", state?.practiceName, "practiceNumber:", state?.practiceNumber);

  if (!state?.practiceName || !state?.practiceNumber) {
    console.log("RETURNING: validation failed (missing practiceName or practiceNumber)");
    setErrorMessage("Practice name and practice number are required");
    return;
  }

  // show practicetypes debug info
  console.log("practicetypes:", practicetypes);
  const practicesList = practicetypes?.practices;
  console.log("practicesList length:", practicesList?.length ?? 0);

  const existsInDB =
    practicesList &&
    practicesList.some(
      (p) => String(p.practiceNumber) === String(state.practiceNumber)
    );

  console.log("existsInDB:", existsInDB);

  if (existsInDB) {
    console.log("RETURNING: duplicate practiceNumber found");
    setErrorMessage("A practice with this Practice Number already exists.");
    return;
  }

  setSavingPractice(true);
  setErrorMessage(null);

  // This is the line you expected to see — it will now definitely run if we didn't return above
  console.log("State before dispatch:", JSON.stringify(state));

  try {
      const result = await dispatch(editPracticeType(practice, "Add"));
  console.log("saved", result);
    setModal(false);
    setstate((prev) => ({
      ...prev,
      practiceName: "",
      practiceNumber: auth?.info?.profile?.practiceNumber || "",
      specialityType: false,
      treatmentType: false,
      extra_info: "",
      base_fare: "",
      base_rate: "",
      consultation_duration: false,
      convenience_fee_type: false,
      convenience_fees: "",
      dispensing_fee: "",
      min_charge: "",
      min_fare: "",
      rate_per_unit_distance: "",
      rate_per_hour: "",
      address: "",
    }));

    setOriginalPracticeInjected(false);
  } catch (err) {
    console.error("addPractice error:", err);
    setErrorMessage("Failed to add practice — try again.");
  } finally {
    setSavingPractice(false);
  }
};





  const columns = [
      { header: "ID", accessorKey: "id" },
    { header: "Practice Name", accessorKey: "practiceName" },
    { header: "Practice Number", accessorKey: "practiceNumber" },
    {
      header: "Service Type",
      accessorKey: "specialityType",
    },
    {
      header: "Treatment type",
      accessorKey: "treatmentType",
    },
    { header: "Base Fare", accessorKey: "base_fare" },
    { header: "Base Rate", accessorKey: "base_rate" },
    { header: "Consultation Duration", accessorKey: "consultation_duration" },
    {
      header: "Convenience fee type",
      accessorKey: "convenience_fee_type",
      lookup: { flat: language.flat, percentage: language.percentage },
    },
    { header: "Convenience fee", accessorKey: "convenience_fees", type: "numeric" },
    { header: "Dispensing Fee", accessorKey: "dispensing_fee", type: "numeric" },
    { header: "Min Charge", accessorKey: "min_charge", type: "numeric" },
    { header: "Min Fare", accessorKey: "min_fare", type: "numeric" },
    {
      header: language.rate_per_unit_distance,
      accessorKey: "rate_per_unit_distance",
      type: "numeric",
    },
    { header: language.rate_per_hour, accessorKey: "rate_per_hour", type: "numeric" },

    { header: language.extra_info, accessorKey: "extra_info" },
    
{
    accessorKey: "address",
    header: "Address (Lat, Lng)",
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value && value.lat && value.lng
        ? `${value.lat.toFixed(5)}, ${value.lng.toFixed(5)}`
        : "Not set";
    },
  },
    
  ];
  const [modal, setModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  const onRowAdd = (newData) => {
    features.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
        setTimeout(() => {
          newData["createdAt"] = new Date().toISOString();
          dispatch(editPracticeType(newData, "Add"));
          resolve();
        }, 600);
      })
      : new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          alert(language.demo_mode);
        }, 600);
      })
  }

  const onRowUpdate = (newData, oldData) => {
    features.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          dispatch(editPracticeType(newData, "Update"));
          dispatch(fetchPracticeTypes());
        }, 600);
      })
      : new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          alert(language.demo_mode);
        }, 600);
      })

  }


  const onRowDelete = (oldData) => {
    features.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          dispatch(editPracticeType(oldData, "Delete"));
        }, 600);
      })
      : new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          alert(language.demo_mode);
        }, 600);
      })

  }
    

  return practicetypes.loading ? (
    <CircularLoading />
  ) : (
    <>
     
       
    </>
  );
}



//  <div>
//         {/* <Select
//           // value={selectedOption}
//           // onChange={this.handleChange}
//           options={icd10codes}
//         /> */}

//         <Button color="danger" onClick={toggle}>
//           Add Details
//         </Button>
//         <Modal
//           centered={true}
//           fade={true}
//           size="lg"
//           isOpen={modal}
//           toggle={toggle}
//         >
//           <ModalHeader>Practice Details</ModalHeader>
//           <ModalBody>
//             <GridItem xs={12} sm={12} md={12} lg={12}>
//               <GridContainer spacing={1}>
//                 <GridItem xs={12}>
//                   <FormText color="default" tag="span">
//                     Pratice Name :
//                   </FormText>

//                   <Input
//                     //returnKeyType={'next'}
//                     fullWidth
//                     bsSize="lg"
//                     // placeholder={"practice name"}
//                     value={state.practiceName}
//                     onChange={(event) => {
//                       setstate({
//                         ...state,
//                         practiceName: event.target.value,
//                       });
//                     }}
//                     customLabelStyles={{
//                       colorFocused: "red",
//                       colorBlurred: "black",
//                       fontSizeFocused: 12,
//                     }}
//                   />
//                 </GridItem>
//                 <GridItem xs={12}>
//                   <FormText color="default" tag="span">
//                     Pratice Number :
//                   </FormText>
//                   <Input
//                     //returnKeyType={'next'}
//                     fullWidth
//                     bsSize="lg"
//                     disabled={true}
//                     value={state.practiceNumber}
//                     // onChange={(event) => {
//                     //   setstate({
//                     //     ...state,
//                     //     practiceNumber: event.target.value,
//                     //   });
//                     // }}
//                     customLabelStyles={{
//                       colorFocused: "red",
//                       colorBlurred: "black",
//                       fontSizeFocused: 12,
//                     }}
//                   />
//                 </GridItem>
//                 <GridItem xs={6}>
//                   <FormText color="default" tag="span">
//                     Service Type :
//                   </FormText>
//                   <Select
//                     id="serviceType"
//                     // value={state.serviceType}
//                     onChange={(event, text) => {
//                       setstate({
//                         ...state,
//                         specialityType: text.props.children,
//                       });
//                       setserviceT(event.target.value);
//                       console.log(event.target.value);

//                       console.log("items ttt", serviceT);
//                     }}
//                     variant="outlined"
//                     fullWidth
//                   >
//                     {service.map((special) => (
//                       <MenuItem value={special.value}>{special.label}</MenuItem>
//                     ))}
//                   </Select>
//                 </GridItem>
//                 <GridItem xs={6}>
//                   <FormText color="default" tag="span">
//                     Treatment Type :
//                   </FormText>
//                   <Select
//                     id="practice-type-native"
//                     // value={state.treatmentType}
//                     onChange={(event) => {
//                       console.log("treatment: ", event.target.value);
//                       setstate((prevState) => ({
//                         ...prevState,
//                         treatmentType: event.target.value,
//                       }));
//                     }}
//                     variant="outlined"
//                     fullWidth
//                   >
//                     {treatments.map((special) => (
//                       <MenuItem value={special.value}>{special.label}</MenuItem>
//                     ))}
//                   </Select>
//                 </GridItem>

//                 <GridItem xs={12}>
//                   <Button color="danger" fullWidth onClick={toggleTwo}>
//                     Add Fees
//                   </Button>
//                 </GridItem>
//                 <Collapse isOpen={isOpen}>
//                   <GridItem xs={12} sm={12} md={12} lg={12}>
//                     <GridContainer spacing={1}>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Base Fare :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.base_fare}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               base_fare: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Base Rate :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.base_rate}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               base_rate: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={12}>
//                         <FormText color="default" tag="span">
//                           Consultation Duration :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           type="select"
//                           fullWidth
//                           // bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.consultation_duration}
//                           onChange={(event) => {
//                             console.log(event);
//                             setstate({
//                               ...state,
//                               consultation_duration: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         >
//                           {/* <option>{service[0].label}</option> */}
//                         </Input>
//                       </GridItem>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Convience Fee Type :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           type="select"
//                           fullWidth
//                           // bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.convenience_fee_type}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               convenience_fee_type: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         >
//                           <option>1</option>
//                           <option>2</option>
//                           <option>3</option>
//                           <option>4</option>
//                           <option>5</option>
//                         </Input>
//                       </GridItem>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Convience Fee :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.convenience_fees}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               convenience_fees: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={4}>
//                         <FormText color="default" tag="span">
//                           Dispensing Fee :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.dispensing_fee}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               dispensing_fee: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={4}>
//                         <FormText color="default" tag="span">
//                           Min Charge :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.min_charge}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               min_charge: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={4}>
//                         <FormText color="default" tag="span">
//                           Min Fare :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.min_fare}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               min_fare: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Distance Rate (km/mile) :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.rate_per_unit_distance}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               rate_per_unit_distance: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                       <GridItem xs={6}>
//                         <FormText color="default" tag="span">
//                           Rate (Per Hour) :
//                         </FormText>
//                         <Input
//                           //returnKeyType={'next'}
//                           fullWidth
//                           bsSize="lg"
//                           // placeholder={"fees"}
//                           value={state.rate_per_hour}
//                           onChange={(event) => {
//                             setstate({
//                               ...state,
//                               rate_per_hour: event.target.value,
//                             });
//                           }}
//                           customLabelStyles={{
//                             colorFocused: "red",
//                             colorBlurred: "black",
//                             fontSizeFocused: 12,
//                           }}
//                         />
//                       </GridItem>
//                     </GridContainer>
//                   </GridItem>
//                 </Collapse>
//                 <GridItem xs={12}>
//                   <FormText color="default" tag="span">
//                     Extra Information :
//                   </FormText>
//                   <Input
//                     type="textarea"
//                     // fullWidth
//                     bsSize="lg"
//                     value={state.extra_info}
//                     onChange={(event) => {
//                       setstate({
//                         ...state,
//                         extra_info: event.target.value,
//                       });
//                     }}
//                     // customLabelStyles={{
//                     //   colorFocused: "red",
//                     //   colorBlurred: "black",
//                     //   fontSizeFocused: 12,
//                     // }}
//                   />
//                 </GridItem>
//               </GridContainer>
//             </GridItem>
//           </ModalBody>
//           <ModalFooter>
//             <Button color="primary" onClick={() => onAdd()}>
//               Add
//             </Button>{" "}
//             <Button color="primary" onClick={toggle}>
//               Cancel
//             </Button>
//           </ModalFooter>
//         </Modal>
//       </div>